import utils from 'utils'
import fuzzySearch from './fuzzysearch'

export default class taxAccountListCtrl {
    constructor($scope, $uibModal, logger, httpRequest, $state, sweetalert, initSortService, operationService, $location) {
        $scope.profileType = '1666596757048'

        function initDict() {
            const dictTypeArr = ['drawer_active_status', 'rollticket_status', 'drawer_channel_type', 'ivat_drawer_channel_type', 'ovat_drawer_channel_type', 'qpt_login_type', 'yes_no_flag', 'identity_type_tax_account', 'tax_belong_region', 'drawer_business_scope']
            return httpRequest.get_dictByTypeArr(JSON.stringify(dictTypeArr)).then((res1) => {
                return res1.data.value
            })
        }
        $scope.importconfig2 = {
            label: '税局账号更新',
            code: 'OVAT_TAX4_DRAWER_UPDATE',
            appName: host.etcloudOvat,
            downloadAppName: host.etcloudOvat,
            url: 'dlTaskService/import_OVAT_TAX4_DRAWER_UPDATE',
            validate: {
                pattern: '.xlsx,.xls,.xml',
                _validate: {
                    size: {
                        min: 10,
                        max: '10MB',
                    },
                    duration: {
                        min: '10s',
                        max: '5m',
                    },
                    accept: '.xlsx,.xls,.xml',
                },
            },
            // downloadUrl: `${downloadUrl}accessToken=${$scope.idToken}`,
            callback() {
                // 回掉，可选
                queryList()
            },
            taxOfficeAccountDownload() {
                let _url = `${host.etcloudOvat
                    }tax4/ovatTax4Drawer/downloadDrawerUpdateTemplate?accessToken=${localStorage.getItem(
                        'id_token'
                    )}`
                utils.file_download(
                    _url,
                    $scope.downloadParam,
                    '', //type
                    'POST',
                    'blob',
                    '',
                    false
                )
            },
        }
        $scope.treeConfig = {
            width: '150%',
            isCheckall: true,
            concatParentChild: true,
            concatParentChildChecked: true,
            check: {
                //如果没有设置配置项，取默认配置
                enable: true, //显示不显示复选框
                chkboxType: { Y: '', N: '' },
            },
        }
        $scope.datePickerConfig = {
            autoclose: true, // 当选择一个日期之后是否立即关闭此日期时间选择器。
            minView: 'month', // 日期时间选择器所能够提供的最精确的时间选择视图。 选择日期后，不会再跳转去选择时分秒
            language: 'zh-CN', // 语言
            format: 'yyyy-mm-dd', // 格式
            forceParse: 0, // 是否强制解析输入框中的值
            pickTime: false,
            pickerPosition: 'bottom-right', // 出现的位置 默认值: 'bottom-right' (还支持 : 'bottom-left')
        }
        $scope.queryParam = {
            pageNum: 1,
            pageSize: 10,
            param: {
                activeStatus: '', //激活标识
                drawerId: '', //开票员编号
                drawerIds: [], //开票员编号
                orgIdList: [$scope.userInfo.org.orgId], //管理范围 机构id列表 默认当前机构
                selectedOrgs: [$scope.userInfo.org],
                realName: '', //真实姓名
                status: '', //状态
                taxAccountName: '', //电子税局登录账号
                channelType: '', //开票员通道类型
                qptProxyUrl: '', //全票通代理Url
            },
        }

        $scope.selectedRows = []

        $scope.customizedConfig = {
            version: 1.91,
            queryConfig: [
                {
                    label: '税务账号编号',
                    key: 'drawerId',
                    type: 'input',
                    dict: '',
                    selected: false,
                },
                {
                    label: '电子税局登录账号',
                    key: 'taxAccountName',
                    type: 'input',
                    dict: '',
                    selected: true,
                },
                {
                    label: '姓名',
                    key: 'realName',
                    type: 'input',
                    dict: '',
                    selected: true,
                },

                {
                    label: '所属机构',
                    key: 'orgIdList',
                    type: 'orgIdList',
                    dict: '',
                    selected: true,
                },
                {
                    label: '状态标识',
                    key: 'status',
                    type: 'select',
                    dict: 'rollticket_status',
                    selected: true,
                },
                {
                    label: '激活标识',
                    key: 'activeStatus',
                    type: 'select',
                    dict: 'drawer_active_status',
                    selected: true,
                },
                {
                    label: '身份类型',
                    key: 'identityType',
                    type: 'select',
                    dict: 'identity_type_tax_account',
                    selected: true,
                },
                {
                    label: '通道类型（销项）',
                    key: 'channelType',
                    type: 'select',
                    dict: 'ovat_drawer_channel_type',
                    selected: false,
                },
                {
                    label: '通道类型（进项）',
                    key: 'ivatChannelType',
                    type: 'select',
                    dict: 'ivat_drawer_channel_type',
                    selected: false,
                },
                {
                    label: '登录方式',
                    key: 'loginType',
                    type: 'select',
                    dict: 'qpt_login_type',
                    selected: false,
                },
                {
                    label: '业务范围',
                    key: 'businessScope',
                    type: 'select',
                    dict: 'drawer_business_scope',
                    selected: false,
                }, {
                    label: '税局地区',
                    key: 'taxBelongRegion',
                    type: 'select',
                    dict: 'tax_belong_region',
                    selected: false,
                },
                {
                    label: '纳税识别号',
                    key: 'creditCode',
                    type: 'input',
                    dict: '',
                    selected: true,
                },
            ],
            table: [
                {
                    label: '主创建机构',
                    key: 'mainOrgName',
                    type: '',
                    dict: '',
                    selected: true,
                },
                {
                    label: '所属机构',
                    key: 'orgName',
                    type: '',
                    dict: '',
                    selected: true,
                },
                {
                    label: '纳税识别号',
                    key: 'creditCode',
                    selected: false,
                },
                {
                    label: '税务账号编号',
                    key: 'drawerId',
                    type: '',
                    dict: '',
                    selected: true,
                },
                {
                    label: '姓名',
                    key: 'realName',
                    type: '',
                    dict: '',
                    selected: true,
                },
                {
                    label: '手机号',
                    key: 'mobile',
                    type: '',
                    dict: '',
                    selected: true,
                },
                {
                    label: '税局登录账号',
                    key: 'taxAccountName',
                    type: '',
                    dict: '',
                    selected: true,
                },
                {
                    label: '税局地区',
                    key: 'taxBelongRegion',
                    type: 'dict',
                    dict: 'tax_belong_region',
                    selected: false,
                },
                {
                    label: '身份类型',
                    key: 'identityType',
                    type: 'dict',
                    dict: 'identity_type_tax_account',
                    selected: true,
                },
                {
                    label: '状态标识',
                    key: 'status',
                    type: 'dict',
                    dict: 'rollticket_status',
                    selected: true,
                },
                {
                    label: '激活标识',
                    key: 'activeStatus',
                    type: 'dict',
                    dict: 'drawer_active_status',
                    selected: true,
                },
                {
                    label: '创建人',
                    key: 'createUser',
                    type: '',
                    dict: '',
                    selected: false,
                },
                {
                    label: '创建时间',
                    key: 'createTime',
                    type: '',
                    dict: '',
                    selected: false,
                },
                {
                    label: '最新修改人',
                    key: 'updateUser',
                    type: '',
                    dict: '',
                    selected: false,
                },
                {
                    label: '最新修改时间',
                    key: 'updateTime',
                    type: '',
                    dict: '',
                    selected: false,
                },
                {
                    label: '最新激活时间',
                    key: 'activeTime',
                    type: '',
                    dict: '',
                    selected: false,
                },
                {
                    label: '通道类型（销项）',
                    key: 'channelType',
                    type: 'dict',
                    dict: 'ovat_drawer_channel_type',
                    selected: false,
                },
                {
                    label: '通道类型（进项）',
                    key: 'ivatChannelType',
                    type: 'dict',
                    dict: 'ivat_drawer_channel_type',
                    selected: false,
                },
                {
                    label: '代理URL',
                    key: 'qptProxyUrl',
                    type: '',
                    dict: '',
                    selected: false,
                },
                {
                    label: '登录方式',
                    key: 'loginType',
                    type: 'dict',
                    dict: 'qpt_login_type',
                    selected: false,
                },
                {
                    label: '是否自动登录默认账号',
                    key: 'isDefault',
                    type: 'dict',
                    dict: 'yes_no_flag',
                    selected: false,
                },
                {
                    label: '备注',
                    key: 'remark',
                    type: '',
                    dict: '',
                    selected: false,
                },
                {
                    label: '业务范围',
                    key: 'ownBusinessScope',
                    type: 'ownBusinessScope',
                    dict: 'drawer_business_scope',
                    selected: false,
                },
                {
                    label: '服务器地址',
                    key: 'qptserverUrl',
                    selected: false,
                },{
                    label: '锁定状态',
                    key: 'orgLockStatus',
                    type: 'orgLockStatus',
                    selected: true,
                },
            ],
        }
        async function init() {
            httpRequest.get_getUserOrgList().then((res) => {
                $scope.orgList = res.data.value
                $scope.selectedOrgs = $scope.orgList.filter((ele) => {
                    if (ele.orgId === $scope.userInfo.org.orgId) {
                        ele.checked = true
                    }
                })
            })
            $scope.dictData = await initDict()
        }
        init()
        $scope.reset = function () {
            $scope.queryParam.param = {
                activeStatus: '', //激活标识
                drawerId: '', //开票员编号
                orgIdList: [$scope.userInfo.org.orgId], //管理范围 机构id列表 默认当前机构
                selectedOrgs: [$scope.userInfo.org],
                realName: '', //真实姓名
                status: '', //状态
                taxAccountName: '', //电子税局登录账号
                channelType: '', //开票员通道类型
                qptProxyUrl: '', //全票通代理Url
            }
        }
        let downloadUrl = 'tax4/ovatTax4Drawer/downloadDrawerUpdateTemplate?'
        //查询功能，和表头排序功能
        function queryList() {
            $scope.queryParam.param.drawerIds = []
            $scope.queryParam.param.orgIdList = $scope.queryParam.param.selectedOrgs.map((ele) => {
                return ele.orgId
            })
            httpRequest
                .post_ovatTax4DrawerfindListByPage($scope.queryParam)
                .then((res) => {
                    let result = res.data.value
                    $scope.dataList = result.list
                    $scope.totalItems = result.total
                    $scope.queryParam.pageNum = result.pageNum
                    $scope.selectedRows = []
                })
            // downloadUrl = 'tax4/ovatTax4Drawer/downloadDrawerUpdateTemplate?'
            let newParam = {
                activeStatus: $scope.queryParam.param.activeStatus, //激活标识
                drawerId: $scope.queryParam.param.drawerId, //开票员编号
                drawerIds: $scope.queryParam.param.drawerIds, //开票员编号
                orgIdList: $scope.queryParam.param.orgIdList, //管理范围
                realName: $scope.queryParam.param.realName, //真实姓名
                status: $scope.queryParam.param.status, //状态
                taxAccountName: $scope.queryParam.param.taxAccountName, //电子税局登录账号
                channelType: $scope.queryParam.param.channelType, //开票员通道类型
                qptProxyUrl: $scope.queryParam.param.qptProxyUrl, //全票通代理Url
                updateExportType: 'taxAccount',
            }
            // Object.keys(newParam).forEach((key) => {
            //     downloadUrl += `${key}=${encodeURI(newParam[key])}&`
            // })
            // $scope.importconfig2.downloadUrl =  `${downloadUrl}accessToken=${$scope.idToken}`
            $scope.downloadParam = newParam
        }
        queryList()
        const pathParam = $location.path().replace(/\//g, '-')
        $scope.orderMap = initSortService(pathParam)
        $scope.queryParam.orderMap = $scope.orderMap.wrap

        $scope.selectedHandle = function () {
            $scope.queryParam.orderMap = $scope.orderMap.wrap
            queryList()
        }
        $scope.search = function () {
            queryList()
        }
        $scope.pageChanged = function () {
            queryList()
        }
        $scope.tableDropdownConfig = [
            {
                label: '详情',
                handler(item) {
                    $state.go('system.basedata.taxAccount.detail', {
                        drawerId: item.drawerId,
                    })
                },
                showWhile(item, hasPermit) {
                    return hasPermit('detail_taxAccount')
                },
            },
            {
                label: '授权',
                handler(item) {
                    $scope.openAuthorizeChangeModel(item)
                },
                showWhile(item, hasPermit) {
                    return hasPermit('power_taxAccount') && item.isOriginalDrawer == '1'
                },
            },
            // {
            //     label: '激活',
            //     handler(item) {
            //         let drawerIds = []
            //         drawerIds.push(item.drawerId)
            //         httpRequest.post_activateDrawer(drawerIds).then((res) => {
            //             logger.logSuccess(res.data.message)
            //             setTimeout(() => {
            //                 queryList()
            //             }, 1000)
            //         })
            //     },
            //     showWhile(item, hasPermit) {
            //         return hasPermit('active_taxAccount') && item.activeStatus !== '2'
            //     },
            // },
            {
                label: '激活',
                handler(item) {
                    let drawerIds = []
                    drawerIds.push(item.drawerId)
                    httpRequest.post_batchActivateDrawer(drawerIds).then((res) => {
                        logger.logSuccess(res.data.message || '激活成功')
                        setTimeout(() => {
                            queryList()
                        }, 1000)
                    })
                },
                showWhile(item, hasPermit) {
                    return hasPermit('active_taxAccount') && item.activeStatus !== '2'
                },
            },
            {
                label: '编辑',
                handler(item) {
                    $state.go('system.basedata.taxAccount.edit', {
                        drawerId: item.drawerId,
                        isOriginalDrawer: item.isOriginalDrawer,
                    })
                },
                showWhile(item, hasPermit) {
                    return hasPermit('edit_taxAccount')
                },
            },
            {
                label: '删除',
                handler(item) {
                    sweetalert.confirm('税务账号删除确认', '您正在进行税务账号删除操作，请确认无误后点击【确定】进行删除?').then(() => {
                        let drawerIds = []
                        drawerIds.push(item.drawerId)
                        let isHasOutput = item.ownBusinessScope.some((el) => el == '0')
                        if (isHasOutput) return logger.logError('有销项业务范围的不能删除')
                        httpRequest.post_deleteTaxAccount(drawerIds).then(() => {
                            logger.logSuccess('删除成功')
                            queryList()
                        })
                    })
                },
                showWhile(item, hasPermit) {
                    return hasPermit('del_taxAccount') && item.identityType !== '9'
                },
            }, {
                label: '解锁',
                handler(item) {
                    let param = {
                        "operationType": '4',
                        "orgId": item.orgId,
                        "taxAccountName": item.taxAccountName,
                        "taxBelongRegion": item.taxBelongRegion,
                    }
                    httpRequest.post_unlock(param).then(() => {
                        logger.logSuccess('解锁成功')
                        queryList()
                    })
                },
                showWhile(item, hasPermit) {
                    return item.orgLockStatus
                },
            },
        ]
        $scope.add = function () {
            $state.go('system.basedata.taxAccount.add')
        }
        $scope.taxAccountActive = function () {
            const drawerIds = []
            if (!$scope.selectedRows.length) return logger.logError('请选择至少一条数据再操作！')
            for (let i = 0; i < $scope.selectedRows.length; i++) {
                drawerIds.push($scope.selectedRows[i].drawerId)
            }
            utils.loading('系统正在批量处理中，请耐心等待... ')
            httpRequest.post_activateDrawer(drawerIds).then((res) => {
                logger.logSuccess(res.data.message)
                setTimeout(() => {
                    queryList()
                }, 1000)
            })
        }
        $scope.delTaxAccount = function () {
            const drawerIds = []
            if (!$scope.selectedRows.length) return logger.logError('请选择至少一条数据再操作！')
            for (let i = 0; i < $scope.selectedRows.length; i++) {
                drawerIds.push($scope.selectedRows[i].drawerId)
            }
            for (let key = 0; key < $scope.selectedRows.length; key++) {
                if ($scope.selectedRows[key].identityType === '9') {
                    logger.logTips('所选的数据中包含业务范围为销项的税务账号，不可删除，请重新选择数据范围。', 'warn')
                    return
                }
            }
            sweetalert.confirm('税务账号删除确认', '您正在进行税务账号删除操作，请确认无误后点击【确定】进行删除?').then(() => {
                httpRequest.post_deleteTaxAccount(drawerIds).then(() => {
                    logger.logSuccess('删除成功')
                    queryList()
                })
            })
        }
        $scope.openAuthorizeChangeModel = function (formObj) {
            $uibModal
                .open({
                    templateUrl: 'authorizeChangeModel.html',
                    controller: [
                        '$scope',
                        '$uibModalInstance',
                        'httpRequest',
                        ($scope, $uibModalInstance, httpRequest) => {
                            $scope.formObj = formObj
                            $scope.dictData = {
                                status_type: [
                                    {
                                        enumCode: '0',
                                        enumName: '未启用',
                                    },
                                    {
                                        enumCode: '1',
                                        enumName: '启用',
                                    },
                                ],
                            }

                            var orgSetting = {
                                check: {
                                    //如果没有设置配置项，取默认配置
                                    enable: true, //显示不显示复选框
                                    chkboxType: {
                                        Y: 's',
                                        N: 'ps',
                                    },
                                },
                                data: {
                                    simpleData: {
                                        enable: true, //true / false 分别表示 使用 / 不使用 简单数据模式
                                        idKey: 'id', //节点数据中保存唯一标识的属性名称 默认值id
                                        pIdKey: 'parentId', //节点数据中保存其父节点唯一标识的属性名称 默认值："pId"
                                        rootPId: null, // 用于修正根节点父节点数据，即 pIdKey 指定的属性值 默认值：null
                                    },
                                    key: {
                                        name: 'name',
                                    },
                                },
                                view: {
                                    showIcon: false, //是否显示节点的图标
                                    showLine: false, //是否显示节点之间的连线
                                },
                                callback: {
                                    onCheck: function (event, treeId, treeNode) {
                                        var changeTreeObj = $.fn.zTree.getZTreeObj('changeOrgTree')
                                        $scope.changeCheckedList = changeTreeObj.getNodes()
                                    },
                                },
                            }
                            var receiveSetting = {
                                check: {
                                    //如果没有设置配置项，取默认配置
                                    enable: true, //显示不显示复选框
                                    chkboxType: {
                                        Y: 's',
                                        N: 'ps',
                                    },
                                },
                                data: {
                                    simpleData: {
                                        enable: true, //true / false 分别表示 使用 / 不使用 简单数据模式
                                        idKey: 'id', //节点数据中保存唯一标识的属性名称 默认值id
                                        pIdKey: 'parentId', //节点数据中保存其父节点唯一标识的属性名称 默认值："pId"
                                        rootPId: null, // 用于修正根节点父节点数据，即 pIdKey 指定的属性值 默认值：null
                                    },
                                    key: {
                                        name: 'name',
                                    },
                                },
                                view: {
                                    showIcon: false, //是否显示节点的图标
                                    showLine: false, //是否显示节点之间的连线
                                },
                                callback: {
                                    onCheck: function (event, treeId, treeNode) {
                                        var receiveTreeObj = $.fn.zTree.getZTreeObj('receiveOrgTree')
                                        var nodes = receiveTreeObj.getCheckedNodes() // 选中的结果值
                                        let repeatData = []
                                        angular.forEach(nodes, (item, index) => {
                                            if (item.drawerDisabledList) {
                                                item.drawerDisabledList.forEach((i, index) => {
                                                    repeatData.push(i)
                                                })
                                            }
                                        })
                                        // 结果值去重 and 格式化展示
                                        duplicateRemoval(repeatData, 1)
                                    },
                                },
                            }
                            var userSetting = {
                                check: {
                                    //如果没有设置配置项，取默认配置
                                    enable: true, //显示不显示复选框
                                    chkboxType: {
                                        Y: 's',
                                        N: 'ps',
                                    },
                                },
                                data: {
                                    simpleData: {
                                        enable: true, //true / false 分别表示 使用 / 不使用 简单数据模式
                                        idKey: 'orgId', //节点数据中保存唯一标识的属性名称 默认值id
                                        pIdKey: 'parentOrgId', //节点数据中保存其父节点唯一标识的属性名称 默认值："pId"
                                        rootPId: null, // 用于修正根节点父节点数据，即 pIdKey 指定的属性值 默认值：null
                                    },
                                    key: {
                                        name: 'showName',
                                    },
                                },
                                view: {
                                    showIcon: false, //是否显示节点的图标
                                    showLine: false, //是否显示节点之间的连线
                                },
                                callback: {
                                    onCheck: function (event, treeId, treeNode) {
                                        var treeObj = $.fn.zTree.getZTreeObj('userTree')
                                        var userListData = treeObj.getCheckedNodes()
                                        let drawerIds = []
                                        angular.forEach(userListData, (item, index) => {
                                            drawerIds.push(item.drawerId)
                                        })
                                        let data = {
                                            drawerIds: drawerIds,
                                        }
                                        // 按开票员查询 - 查询开票员管理范围
                                        httpRequest.post_getDrawersManagementScope(data).then((res) => {
                                            // 结果值去重 and 格式化展示
                                            duplicateRemoval(res.data.value, 2)
                                        })
                                    },
                                },
                            }
                            var resultSetting = {
                                check: {
                                    //如果没有设置配置项，取默认配置
                                    enable: true, //显示不显示复选框
                                    chkboxType: {
                                        Y: 's',
                                        N: 'ps',
                                    },
                                },
                                data: {
                                    simpleData: {
                                        enable: true, //true / false 分别表示 使用 / 不使用 简单数据模式
                                        idKey: 'id', //节点数据中保存唯一标识的属性名称 默认值id
                                        pIdKey: 'pid', //节点数据中保存其父节点唯一标识的属性名称 默认值："pId"
                                        rootPId: null, // 用于修正根节点父节点数据，即 pIdKey 指定的属性值 默认值：null
                                    },
                                    key: {
                                        name: 'showName',
                                    },
                                },
                                view: {
                                    showIcon: false, //是否显示节点的图标
                                    showLine: false, //是否显示节点之间的连线
                                },
                                callback: {
                                    onCheck: function (event, treeId, treeNode) {
                                        var treeObj = $.fn.zTree.getZTreeObj('resultDataTree')
                                        $scope.resultData = treeObj.getNodes() // 树结构展示list
                                    },
                                },
                            }
                            // 转交管理范围 - 选择管理机构树
                            var deliverSetting = {
                                check: {
                                    //如果没有设置配置项，取默认配置
                                    enable: true, //显示不显示复选框
                                    chkboxType: {
                                        Y: 's',
                                        N: 'ps',
                                    },
                                },
                                data: {
                                    simpleData: {
                                        enable: true, //true / false 分别表示 使用 / 不使用 简单数据模式
                                        idKey: 'id', //节点数据中保存唯一标识的属性名称 默认值id
                                        pIdKey: 'parentId', //节点数据中保存其父节点唯一标识的属性名称 默认值："pId"
                                        rootPId: null, // 用于修正根节点父节点数据，即 pIdKey 指定的属性值 默认值：null
                                    },
                                    key: {
                                        name: 'name',
                                    },
                                },
                                view: {
                                    showIcon: false, //是否显示节点的图标
                                    showLine: false, //是否显示节点之间的连线
                                },
                                callback: {
                                    onCheck: function (event, treeId, treeNode) {
                                        var deliverTreeObj = $.fn.zTree.getZTreeObj('deliverOrgTree')
                                        var nodes = deliverTreeObj.getCheckedNodes() // 选中的结果值
                                        $scope.resultDrawerIds = []
                                        let repeatData = []
                                        angular.forEach(nodes, (item, index) => {
                                            if (item.drawerEnableList.length > 0) {
                                                item.drawerEnableList.forEach((i, index) => {
                                                    repeatData.push({
                                                        id: randomID(),
                                                        pid: randomID(),
                                                        drawerId: i.originalDrawerId,
                                                        showName: i.realName + '(' + i.originalDrawerId + '/' + i.taxAccountName + ')',
                                                    })
                                                })
                                            }
                                            if (item.drawerList.length > 0) {
                                                item.drawerList.forEach((i, index) => {
                                                    $scope.resultDrawerIds.push(i.drawerId)
                                                })
                                            }
                                        })
                                        // 选择交接人员 展示数据
                                        resultUserDataFormat(repeatData)
                                    },
                                },
                            }
                            var resultUserSetting = {
                                check: {
                                    //如果没有设置配置项，取默认配置
                                    enable: true, //显示不显示复选框
                                    chkStyle: 'radio',
                                    radioType: 'level',
                                    chkboxType: {
                                        Y: 's',
                                        N: 'ps',
                                    },
                                },
                                data: {
                                    simpleData: {
                                        enable: true, //true / false 分别表示 使用 / 不使用 简单数据模式
                                        idKey: 'id', //节点数据中保存唯一标识的属性名称 默认值id
                                        pIdKey: 'pid', //节点数据中保存其父节点唯一标识的属性名称 默认值："pId"
                                        rootPId: null, // 用于修正根节点父节点数据，即 pIdKey 指定的属性值 默认值：null
                                    },
                                    key: {
                                        name: 'showName',
                                    },
                                },
                                view: {
                                    showIcon: false, //是否显示节点的图标
                                    showLine: false, //是否显示节点之间的连线
                                },
                                callback: {
                                    onCheck: function (event, treeId, treeNode) {
                                        var treeObj = $.fn.zTree.getZTreeObj('resultUserDataTree')
                                        $scope.resultUserData = treeObj.getCheckedNodes()
                                    },
                                },
                            }

                            async function init() {
                                // 获取当前开票员变更管理机构树
                                await httpRequest.post_getChangeManageOrgTree({ drawerId: formObj.drawerId }).then((res) => {
                                    $scope.orgListData = res.data.value
                                })
                                // 获取当前开票员接收管理机构树
                                await httpRequest.post_getReceiveManageOrgTree({ drawerId: formObj.drawerId }).then((res) => {
                                    $scope.receiveListData = res.data.value
                                })
                                // 获取当前开票员转交管理机构树
                                await httpRequest.post_getTransferManageOrgTree({ drawerId: formObj.drawerId }).then((res) => {
                                    $scope.deliverListData = res.data.value

                                    $scope.resultDrawerIds = []
                                    let repeatData = []
                                    angular.forEach($scope.deliverListData, (item, index) => {
                                        if (item.checked && item.drawerEnableList.length > 0) {
                                            item.drawerEnableList.forEach((i, index) => {
                                                repeatData.push({
                                                    id: randomID(),
                                                    pid: randomID(),
                                                    drawerId: i.originalDrawerId,
                                                    showName: i.realName + '(' + i.originalDrawerId + '/' + i.taxAccountName + ')',
                                                })
                                            })
                                        }
                                        if (item.drawerList.length > 0) {
                                            item.drawerList.forEach((i, index) => {
                                                $scope.resultDrawerIds.push(i.drawerId)
                                            })
                                        }
                                    })
                                    // 选择交接人员 展示数据
                                    resultUserDataFormat(repeatData)
                                })
                                // 按开票员查询
                                await httpRequest.post_ovatTax4DrawerUserOrgList().then((res) => {
                                    $scope.userListData = res.data.value
                                    angular.forEach($scope.userListData, (item, index) => {
                                        item.showName = item.realName + '(' + item.drawerId + '/' + item.taxAccountName + ')'
                                    })
                                })
                                $.fn.zTree.init($('#changeOrgTree'), orgSetting, $scope.orgListData)
                                $.fn.zTree.init($('#receiveOrgTree'), receiveSetting, $scope.receiveListData)
                                $.fn.zTree.init($('#deliverOrgTree'), deliverSetting, $scope.deliverListData)
                                $.fn.zTree.init($('#userTree'), userSetting, $scope.userListData)

                                fuzzySearch('changeOrgTree', '#search_changeOrgTree')
                                fuzzySearch('receiveOrgTree', '#search_receiveOrgTree')
                                fuzzySearch('deliverOrgTree', '#search_deliverOrgTree') // 转交管理范围 - 选择管理机构树
                                fuzzySearch('userTree', '#search_userTree')

                                setChangeCheck()
                                setReceiveCheck()
                                setDeliverCheck()
                                $('#py_change').bind('change', setChangeCheck)
                                $('#sy_change').bind('change', setChangeCheck)
                                $('#pn_change').bind('change', setChangeCheck)
                                $('#sn_change').bind('change', setChangeCheck)

                                $('#py_receive').bind('change', setReceiveCheck)
                                $('#sy_receive').bind('change', setReceiveCheck)
                                $('#pn_receive').bind('change', setReceiveCheck)
                                $('#sn_receive').bind('change', setReceiveCheck)

                                $('#py_deliver').bind('change', setDeliverCheck)
                                $('#sy_deliver').bind('change', setDeliverCheck)
                                $('#pn_deliver').bind('change', setDeliverCheck)
                                $('#sn_deliver').bind('change', setDeliverCheck)
                            }
                            setTimeout(() => {
                                init()
                            }, 500)

                            function setChangeCheck() {
                                let zTree = $.fn.zTree.getZTreeObj('changeOrgTree'),
                                    py = $('#py_change').attr('checked') ? 'p' : '',
                                    sy = $('#sy_change').attr('checked') ? 's' : '',
                                    pn = $('#pn_change').attr('checked') ? 'p' : '',
                                    sn = $('#sn_change').attr('checked') ? 's' : '',
                                    type = { Y: py + sy, N: pn + sn }
                                zTree.setting.check.chkboxType = type
                            }
                            function setReceiveCheck() {
                                let zTree = $.fn.zTree.getZTreeObj('receiveOrgTree'),
                                    py = $('#py_receive').attr('checked') ? 'p' : '',
                                    sy = $('#sy_receive').attr('checked') ? 's' : '',
                                    pn = $('#pn_receive').attr('checked') ? 'p' : '',
                                    sn = $('#sn_receive').attr('checked') ? 's' : '',
                                    type = { Y: py + sy, N: pn + sn }
                                zTree.setting.check.chkboxType = type
                            }
                            function setDeliverCheck() {
                                let zTree = $.fn.zTree.getZTreeObj('deliverOrgTree'),
                                    py = $('#py_deliver').attr('checked') ? 'p' : '',
                                    sy = $('#sy_deliver').attr('checked') ? 's' : '',
                                    pn = $('#pn_deliver').attr('checked') ? 'p' : '',
                                    sn = $('#sn_deliver').attr('checked') ? 's' : '',
                                    type = { Y: py + sy, N: pn + sn }
                                zTree.setting.check.chkboxType = type
                            }
                            $scope.changeOrgCheckAll = function (type) {
                                let treeObj = $.fn.zTree.getZTreeObj('changeOrgTree')
                                treeObj.checkAllNodes(type)
                                $scope.changeCheckedList = treeObj.getNodes()
                            }
                            $scope.changeOrgOpenAll = function (type) {
                                let treeObj = $.fn.zTree.getZTreeObj('changeOrgTree')
                                treeObj.expandAll(type)
                            }
                            $scope.receiveOrgCheckAll = function (type) {
                                let treeObj = $.fn.zTree.getZTreeObj('receiveOrgTree')
                                treeObj.checkAllNodes(type)
                                var nodes = treeObj.getCheckedNodes() // 选中的结果值
                                let repeatData = []
                                angular.forEach(nodes, (item, index) => {
                                    if (item.drawerDisabledList) {
                                        item.drawerDisabledList.forEach((i, index) => {
                                            repeatData.push(i)
                                        })
                                    }
                                })
                                // 结果值去重 and 格式化展示
                                duplicateRemoval(repeatData, 1)
                            }
                            $scope.receiveOrgOpenAll = function (type) {
                                let treeObj = $.fn.zTree.getZTreeObj('receiveOrgTree')
                                treeObj.expandAll(type)
                            }
                            $scope.deliverOrgCheckAll = function (type) {
                                let treeObj = $.fn.zTree.getZTreeObj('deliverOrgTree')
                                treeObj.checkAllNodes(type)
                                var nodes = treeObj.getCheckedNodes() // 选中的结果值
                                $scope.resultDrawerIds = []
                                let repeatData = []
                                angular.forEach(nodes, (item, index) => {
                                    if (item.drawerEnableList.length > 0) {
                                        item.drawerEnableList.forEach((i, index) => {
                                            repeatData.push({
                                                id: randomID(),
                                                pid: randomID(),
                                                drawerId: i.originalDrawerId,
                                                showName: i.realName + '(' + i.originalDrawerId + '/' + i.taxAccountName + ')',
                                            })
                                        })
                                    }
                                    if (item.drawerList.length > 0) {
                                        item.drawerList.forEach((i, index) => {
                                            $scope.resultDrawerIds.push(i.drawerId)
                                        })
                                    }
                                })
                                // 选择交接人员 展示数据
                                resultUserDataFormat(repeatData)
                            }
                            $scope.deliverOrgOpenAll = function (type) {
                                let treeObj = $.fn.zTree.getZTreeObj('deliverOrgTree')
                                treeObj.expandAll(type)
                            }
                            $scope.userCheckAll = function (type) {
                                let treeObj = $.fn.zTree.getZTreeObj('userTree')
                                treeObj.checkAllNodes(type)
                                var userListData = treeObj.getCheckedNodes()
                                let drawerIds = []
                                angular.forEach(userListData, (item, index) => {
                                    drawerIds.push(item.drawerId)
                                })
                                let data = {
                                    drawerIds: drawerIds,
                                }
                                // 按开票员查询 - 查询开票员管理范围
                                httpRequest.post_getDrawersManagementScope(data).then((res) => {
                                    // 结果值去重 and 格式化展示
                                    duplicateRemoval(res.data.value, 2)
                                })
                            }
                            $scope.resultCheckAll = function (type) {
                                let treeObj = $.fn.zTree.getZTreeObj('resultDataTree')
                                treeObj.checkAllNodes(type)
                                $scope.resultData = treeObj.getNodes() // 树结构展示list
                            }
                            $scope.isChangeOrgKey = true
                            $scope.isReceiveOrgKey = false
                            $scope.isDeliverOrgKey = false
                            $scope.changeType = function (v) {
                                switch (v) {
                                    case 1:
                                        $scope.isChangeOrgKey = true
                                        $scope.isReceiveOrgKey = false
                                        $scope.isDeliverOrgKey = false
                                        document.getElementById('isChangeOrg').className = 'is-type-selected'
                                        document.getElementById('isReceiveOrg').className = 'no-type-selected'
                                        document.getElementById('isDeliverOrg').className = 'no-type-selected'
                                        break
                                    case 2:
                                        $scope.isChangeOrgKey = false
                                        $scope.isReceiveOrgKey = true
                                        $scope.isDeliverOrgKey = false
                                        document.getElementById('isChangeOrg').className = 'no-type-selected'
                                        document.getElementById('isReceiveOrg').className = 'is-type-selected'
                                        document.getElementById('isDeliverOrg').className = 'no-type-selected'
                                        break
                                    case 3:
                                        $scope.isChangeOrgKey = false
                                        $scope.isReceiveOrgKey = false
                                        $scope.isDeliverOrgKey = true
                                        document.getElementById('isChangeOrg').className = 'no-type-selected'
                                        document.getElementById('isReceiveOrg').className = 'no-type-selected'
                                        document.getElementById('isDeliverOrg').className = 'is-type-selected'
                                        break
                                    default:
                                        break
                                }
                            }

                            $scope.isOrgSelected = true
                            $scope.isUserSelected = false
                            $scope.searchData = function (v) {
                                switch (v) {
                                    case 1:
                                        $scope.isOrgSelected = true
                                        $scope.isUserSelected = false
                                        document.getElementById('getOrgSearch').className = 'is-selected col-sm-6'
                                        document.getElementById('getUserSearch').className = 'no-selected col-sm-6'

                                        break
                                    case 2:
                                        $scope.isOrgSelected = false
                                        $scope.isUserSelected = true
                                        document.getElementById('getOrgSearch').className = 'no-selected col-sm-6'
                                        document.getElementById('getUserSearch').className = 'is-selected col-sm-6'
                                        break
                                    default:
                                        break
                                }
                            }

                            // 授权 - 变更管理机构 数据格式化
                            function changeOrgDataFormat() {
                                let orgIds = []

                                let result = []
                                function flatTree(nodes, parentId) {
                                    if (!nodes || nodes.length === 0) return []
                                    nodes.forEach((node) => {
                                        result.push({
                                            id: node.id,
                                            parentOrgId: parentId,
                                            name: node.name,
                                            checked: node.checked,
                                        })
                                        return flatTree(node.children, node.id)
                                    })
                                }
                                flatTree($scope.changeCheckedList, 0)

                                angular.forEach(result, (item, index) => {
                                    if (item.checked) {
                                        orgIds.push(item.id)
                                    }
                                })
                                const data = {
                                    drawerId: formObj.drawerId,
                                    orgIds: orgIds,
                                }
                                return data
                            }
                            $scope.originalInOrgSearchList = []
                            $scope.originalInUserSearchList = []
                            // 交接开票 - 管理范围结果值 -  去重后 数据格式化展示
                            function duplicateRemoval(repeatData, type) {
                                let inOrgSearchList = [] // 按组织机构查询树集合
                                let inUserSearchList = [] // 按开票员查询树集合
                                if (type === 1) {
                                    //组织机构
                                    angular.forEach(repeatData, (item, index) => {
                                        inOrgSearchList.push({
                                            drawerId: item.drawerId,
                                            showName: item.realName,
                                            id: randomID(),
                                            pid: randomID(),
                                            open: true,
                                            children: [],
                                        })
                                    })
                                    var obj = {}
                                    inOrgSearchList = inOrgSearchList.reduce(function (item, next) {
                                        obj[next.drawerId] ? '' : (obj[next.drawerId] = true && item.push(next))
                                        return item
                                    }, [])
                                    angular.forEach(inOrgSearchList, (item, index) => {
                                        angular.forEach(repeatData, (i, ind) => {
                                            if (item.drawerId === i.drawerId) {
                                                item.children.push({
                                                    id: randomID(),
                                                    pid: item.id,
                                                    orgId: i.orgId,
                                                    orgName: i.orgName,
                                                    drawerId: i.drawerId,
                                                    showName: i.orgName + '-' + i.realName,
                                                })
                                            }
                                        })
                                    })
                                    $scope.originalInOrgSearchList = inOrgSearchList
                                } else {
                                    //开票员
                                    angular.forEach(repeatData, (item, index) => {
                                        if (item.childDrawerOrgVo.length > 0) {
                                            inUserSearchList.push({
                                                drawerId: item.drawerId,
                                                showName: item.realName,
                                                id: randomID(),
                                                pid: randomID(),
                                                open: true,
                                                children: item.childDrawerOrgVo,
                                            })
                                        }
                                    })
                                    angular.forEach(inUserSearchList, (item, index) => {
                                        item.children.forEach((i, ind) => {
                                            i.id = randomID()
                                            i.pid = item.id
                                            i.showName = i.orgName + '-' + i.realName
                                        })
                                    })
                                    $scope.originalInUserSearchList = inUserSearchList
                                }
                                // 管理范围结果值 存在已选择数据 需先对比去重后，再判断是否需要插入新数据
                                if ($scope.originalInOrgSearchList.length > 0 && $scope.originalInUserSearchList.length > 0) {
                                    let newUserList = [...$scope.originalInOrgSearchList, ...$scope.originalInUserSearchList]
                                    var obj = {}
                                    newUserList = newUserList.reduce(function (item, next) {
                                        obj[next.drawerId] ? '' : (obj[next.drawerId] = true && item.push(next))
                                        return item
                                    }, [])
                                    resultDataFormat(newUserList)
                                } else {
                                    if ($scope.originalInOrgSearchList.length > 0) {
                                        resultDataFormat($scope.originalInOrgSearchList)
                                    } else {
                                        resultDataFormat($scope.originalInUserSearchList)
                                    }
                                }
                            }
                            //随机ID
                            function randomID() {
                                return Math.floor(Math.random() * 10000)
                            }
                            // 交接开票 - 管理范围结果值 -  数据格式化
                            function resultDataFormat(resultData) {
                                $.fn.zTree.init($('#resultDataTree'), resultSetting, resultData)
                                fuzzySearch('resultDataTree', '#search_resultDataTree')
                            }
                            // 授权 - 接收管理范围 数据格式化
                            function receiveOrgDataFormat() {
                                let drawerIds = []
                                angular.forEach($scope.resultData, (item, index) => {
                                    if (item.children) {
                                        item.children.forEach((ele) => {
                                            if (ele.checked) {
                                                drawerIds.push(ele.drawerId)
                                            }
                                        })
                                    }
                                })
                                const data = {
                                    drawerId: formObj.drawerId,
                                    drawerIds: drawerIds,
                                }
                                return data
                            }
                            // 授权 - 转交管理范围值 -  数据格式化
                            function resultUserDataFormat(resultData) {
                                var obj = {}
                                resultData = resultData.reduce(function (item, next) {
                                    obj[next.drawerId] ? '' : (obj[next.drawerId] = true && item.push(next))
                                    return item
                                }, [])
                                $.fn.zTree.init($('#resultUserDataTree'), resultUserSetting, resultData)
                                fuzzySearch('resultUserDataTree', '#search_resultUserDataTree')
                            }
                            // 授权 - 转交管理范围 数据格式化
                            function deliverOrgDataFormat() {
                                if ($scope.resultUserData) {
                                    const data = {
                                        drawerId: $scope.resultUserData[0].drawerId,
                                        drawerIds: $scope.resultDrawerIds,
                                    }
                                    return data
                                }
                            }
                            let flag = false
                            function checkData(data) {
                                if (data) {
                                    flag = true
                                    httpRequest.post_transferContrast(data).then((res) => {
                                        if (res.data.value.length > 0) {
                                            flag = true
                                            $uibModal.open({
                                                templateUrl: 'resultModel.html',
                                                controller: [
                                                    '$scope',
                                                    '$uibModalInstance',
                                                    ($scope, $uibModalInstance) => {
                                                        $scope.realName = '开票员'
                                                        $scope.formData = res.data.value
                                                        $scope.cancel = function cancel() {
                                                            $uibModalInstance.dismiss(data)
                                                        }
                                                    },
                                                ],
                                                openedClass: 'mod-modal mod-modal-hg',
                                                backdrop: 'static',
                                            })
                                        } else {
                                            flag = false
                                            return flag
                                        }
                                    })
                                } else {
                                    return flag
                                }
                            }
                            function submitData() {
                                let changeOrgData = changeOrgDataFormat()
                                let receiveOrgData = receiveOrgDataFormat()
                                let deliverOrgData = deliverOrgDataFormat()
                                let data = {}
                                if (changeOrgData.orgIds.length > 0) {
                                    data.change = changeOrgDataFormat()
                                }
                                if (receiveOrgData.drawerIds.length > 0) {
                                    data.receive = receiveOrgDataFormat()
                                }
                                if (deliverOrgData) {
                                    data.transfer = deliverOrgDataFormat()
                                }
                                return data
                            }
                            $scope.ok = function ok() {
                                let data = submitData()
                                if (!data.change && !data.receive && !data.transfer) {
                                    return logger.logError('请选择变更管理范围')
                                }
                                if (checkData(data.transfer)) return
                                utils.loading('请求发送中...')
                                httpRequest.post_scopeOfAuth(data).then((res) => {
                                    logger.logSuccess('变更成功')
                                    $uibModalInstance.close()
                                    setTimeout(() => {
                                        queryList()
                                    }, 1000)
                                })
                            }
                            $scope.cancel = function cancel() {
                                $uibModalInstance.dismiss()
                            }
                        },
                    ],
                    resolve: {
                        items1() {
                            return $scope.drawerList
                        },
                    },
                    openedClass: 'mod-modal mod-modal-hg-gg',
                    backdrop: 'static',
                })
                .result.then((result) => {
                    if (result) {
                    }
                })
        }
        // 导入配置
        $scope.importconfig = {
            label: '新增导入',
            code: 'OVAT_TAX_ACCOUNT_IMPORT',
            appName: host.etcloudOvat,
            downloadAppName: host.etcloudOvat,
            url: 'dlTaskService/import_OVAT_TAX_ACCOUNT_IMPORT',
            validate: {
                pattern: '.xlsx,.xls,.xml',
                _validate: {
                    size: {
                        min: 10,
                        max: '10MB',
                    },
                    duration: {
                        min: '10s',
                        max: '5m',
                    },
                    accept: '.xlsx,.xls,.xml',
                },
            },
            callback() {
                // 回掉，可选
                queryList()
            },
        }

        $scope.$watch('selectedRows.length', () => {
            if (!$scope.selectedRows.length) {
                $scope.queryParam.param.drawerIds = []
            } else {
                $scope.queryParam.param.drawerIds = $scope.selectedRows.map((ele) => {
                    return Number(ele.drawerId)
                })
            }
            // downloadUrl = 'tax4/ovatTax4Drawer/downloadDrawerUpdateTemplate?'
            let newParam = {
                activeStatus: $scope.queryParam.param.activeStatus, //激活标识
                drawerId: $scope.queryParam.param.drawerId, //开票员编号
                drawerIds: $scope.queryParam.param.drawerIds, //开票员编号
                orgIdList: $scope.queryParam.param.orgIdList, //管理范围
                realName: $scope.queryParam.param.realName, //真实姓名
                status: $scope.queryParam.param.status, //状态
                taxAccountName: $scope.queryParam.param.taxAccountName, //电子税局登录账号
                channelType: $scope.queryParam.param.channelType, //开票员通道类型
                qptProxyUrl: $scope.queryParam.param.qptProxyUrl, //全票通代理Url
                updateExportType: 'taxAccount',
            }
            // Object.keys(newParam).forEach((key) => {
            //     downloadUrl += `${key}=${encodeURI(newParam[key])}&`
            // })
            // $scope.importconfig2.downloadUrl =  `${downloadUrl}accessToken=${$scope.idToken}`
            $scope.downloadParam = newParam
        })
        $scope.taxOfficeAccountUpdate = () => {

        }
        $scope.batchActive = function () {
            if (!$scope.selectedRows.length) return logger.logError('请选择至少一条数据再操作！')
            const drawerIds = $scope.selectedRows.map((el) => el.drawerId)
            utils.loading('系统正在批量处理中，请耐心等待... ')
            httpRequest.post_batchActivateDrawer(drawerIds).then((res) => {
                logger.logSuccess(res.data.message || '批量激活成功')
                setTimeout(() => {
                    queryList()
                }, 1000)
            })
        }
        $scope.lockRecord = function () {
            $state.go('system.basedata.taxAccount.lockRecordList')
        }
    }
}
taxAccountListCtrl.$inject = ['$scope', '$uibModal', 'logger', 'httpRequest', '$state', 'sweetalert', 'initSortService', 'operationService', '$location']



// WEBPACK FOOTER //
// ./src/app/system/basedata/taxAccount/list.js